export default {
      id: "oc-checkbox-some-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-checkbox-some",
      toString: function () {
        return this.url;
      }
    }